import type { AnalyticsProvider } from "../types"

// Dev logger: prints the analytics stream to the console so events are visible
// locally without sending anything. Selected when analytics is disabled but
// NODE_ENV !== "production".
function tag(distinctId: string | undefined) {
  return distinctId ? { distinctId } : {}
}

export const consoleProvider: AnalyticsProvider = {
  capture(distinctId, event, properties) {
    console.debug(
      `[analytics] capture ${event}`,
      properties ?? {},
      tag(distinctId)
    )
  },
  identify(distinctId, properties) {
    console.debug(`[analytics] identify`, { distinctId }, properties ?? {})
  },
  alias(distinctId, alias) {
    console.debug(`[analytics] alias`, { distinctId, alias })
  },
  captureException(error, distinctId, properties) {
    console.debug(
      `[analytics] exception`,
      error,
      properties ?? {},
      tag(distinctId)
    )
  },
}
